import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { ApiClientService } from 'src/app/core/services/api-client.service';
import { forkJoin } from 'rxjs';

interface QueueStats {
  queueDepth: number;
  inFlightCount: number;
  dlqCount: number;
}

interface QueueRow {
  name: string;
  stats: QueueStats;
}

interface BufferedGatewayStats {
  totalBuffered: number;
  activeGroups: number;
  oldestEventAgeSeconds: number;
  lastFlushAt: string | null;
  totalFlushErrors: number;
}

interface BufferedGatewayRow {
  name: string;
  stats: BufferedGatewayStats;
}

interface DbPoolStats {
  acquired: number;
  allocated: number;
  idle: number;
  pending: number;
  maxAllocated: number;
  maxPending: number;
}

@Component({
  selector: 'app-system-status',
  templateUrl: './system-status.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SystemStatusComponent implements OnInit {
  healthStatus: string | null = null;
  queues: QueueRow[] = [];
  gateways: BufferedGatewayRow[] = [];
  dbPool: DbPoolStats | null = null;
  loading = true;
  error = false;

  constructor(private api: ApiClientService) {}

  ngOnInit(): void {
    forkJoin({
      health: this.api.getActuatorHealth(),
      queues: this.api.getQueueStatus(),
      gateways: this.api.getBufferedGatewayStatus(),
      dbPool: this.api.getDbPoolStatus()
    }).subscribe({
      next: ({ health, queues, gateways, dbPool }) => {
        this.healthStatus = health.status;
        this.queues = Object.entries(queues).map(([name, stats]) => ({ name, stats }));
        this.gateways = Object.entries(gateways).map(([name, stats]) => ({ name, stats }));
        this.dbPool = dbPool;
        this.loading = false;
      },
      error: () => {
        this.error = true;
        this.loading = false;
      }
    });
  }
}
